<template lang="pug">
.customer-picture
  img.rounded-circle.img-72(
    :src="imgSrc"
    style='object-fit: cover;'
  )
  .customer-grade.rounded-circle.d-flex.justify-content-center.align-items-center(
    :styles="`background-color: ${COLORS[grade]}`"
  )
    | {{ grade ? grade.toUpperCase() : '-' }}
</template>

<script>
export default {
  props: {
    imgSrc: {
      default: 'http://placekitten.com/72/72',
    },
    grade: {
      default: '-', // TODO: define background color by grade
    },
  },
  data: () => ({
    COLORS: {
      a: 'green',
    },
  }),
};
</script>

<style lang="scss">
.customer-picture {
  height: fit-content;
  position: relative;
  .customer-grade {
    width: 32px;
    height: 32px;
    color: var(--white);
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: var(--success);
    border: 1px solid var(--success);
    box-shadow: inset 0 0 0 1px var(--white);
  }
}
</style>
